import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { CallANPR } from '@classes/anpr/callANPR';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { LicenseService } from '@services/anpr/license.service';

@Component({
  selector: 'app-anpr-zone',
  templateUrl: './anpr-zone.component.html',
  styleUrls: ['./anpr-zone.component.scss'],
})
export class AnprZoneComponent {
  @Input() call: CallANPR;
  @Output() answerEvent = new EventEmitter<CallANPR>();
  @Input() img: any;
  @Input() isLoading: boolean;

  constructor(
    private _snackBar: MatSnackBar,
    private licenseService: LicenseService
  ) {}

  emitAnswer(answer: CallANPR) {
    this.answerEvent.emit(answer);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
    });
  }

  onAnswer(correct: boolean) {
    this.licenseService.answer(this.call.id, correct).subscribe((res) => {
      this.emitAnswer(res);
    });
    this.openSnackBar(`You answered ${correct ? 'YES' : 'NO'}`, 'OK');
  }
}
